import { __assign, __extends, __rest } from "tslib";
import * as React from 'react';
import { StyleSheet, View, Image } from 'react-native';
import { grey200 } from '../styles/colors';
/**
 * A component to show a cover image inside a Card.
 *
 * ## Usage
 * ```js
 * import * as React from 'react';
 * import { PnmacCard } from 'pnmac-universal-components';
 *
 * const MyComponent = () => (
 *   <Card>
 *     <Card.Cover source={{ uri: 'https://picsum.photos/700' }} />
 *   </Card>
 * );
 *
 * export default MyComponent;
 * ```
 *
 */
var PnmacCardCover = /** @class */function (_super) {
  __extends(PnmacCardCover, _super);
  function PnmacCardCover() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PnmacCardCover.prototype.render = function () {
    var _a = this.props,
      index = _a.index,
      total = _a.total,
      style = _a.style,
      rest = __rest(_a, ["index", "total", "style"]);
    var coverStyle;
    if (index === 0) {
      if (total === 1) {
        coverStyle = {
          borderRadius: 10
        };
      } else {
        coverStyle = {
          borderTopLeftRadius: 10,
          borderTopRightRadius: 10
        };
      }
    } else if (typeof total === 'number' && index === total - 1) {
      coverStyle = {
        borderBottomLeftRadius: 10
      };
    }
    return /*#__PURE__*/React.createElement(View, {
      style: [styles.container, coverStyle, style]
    }, /*#__PURE__*/React.createElement(Image, __assign({}, rest, {
      style: [styles.image, coverStyle]
    })));
  };
  PnmacCardCover.displayName = 'PnmacCard.Cover';
  return PnmacCardCover;
}(React.Component);
var styles = StyleSheet.create({
  container: {
    height: 195,
    backgroundColor: grey200,
    overflow: 'hidden'
  },
  image: {
    flex: 1,
    height: undefined,
    width: undefined,
    padding: 16,
    justifyContent: 'flex-end',
    resizeMode: 'cover'
  }
});
export default PnmacCardCover;